/**
 * Suppress the benign "ResizeObserver loop ..." browser notice.
 *
 * Recharts' ResponsiveContainer observes its parent with a ResizeObserver.
 * When several charts re-render and resize in the same frame — e.g. switching
 * the dashboard date range, which refetches the Aging / Invoices / Estimates /
 * Requests charts at once — the browser reports:
 *   "ResizeObserver loop completed with undelivered notifications."
 *   "ResizeObserver loop limit exceeded"
 * These are warnings, not errors: the browser simply deferred the remaining
 * resize callbacks to the next frame. Nothing is broken. But CRA's dev error
 * overlay (and window-level error trackers) escalate them to fatal runtime
 * errors, which is noise.
 *
 * We register in the capture phase so this runs before the dev overlay's own
 * window 'error' listener and can stop the event from reaching it.
 */
const IGNORED = /^ResizeObserver loop (limit exceeded|completed with undelivered notifications)/;

function isResizeObserverError(message) {
  return typeof message === "string" && IGNORED.test(message);
}

window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverError(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);
